module.exports = __webpack_public_path__ + "static/img/code.c8fccc24.png";